const runningAppUrl = 'https://127.0.0.1:8080/login';

const amazonAuth = {
  ClientId: '5lofsvskbd6k1b87osf0h3dams',
  AppWebDomain: 'bookingbug-dev.auth.eu-west-1.amazoncognito.com',
  TokenScopesArray: ['openid', 'email', 'phone', 'profile'],
  RedirectUriSignIn: runningAppUrl,
  RedirectUriSignOut: runningAppUrl,
  UserPoolId: 'eu-west-1_CB9uzoyFl',
  AdvancedSecurityDataCollectionFlag: false,
};

export default amazonAuth;
